import classname from 'classnames/bind';

/**
 * cls
 */
export default (csspath: Record<string, string>) => {
	return classname.bind(csspath);
};
